import {ReactNode} from "react";
import {OpenAIProvider} from "./openAI/OpenAIProvider";
import {DeepSeekProvider} from "./deepseek/DeepSeekProvider";
import {GeminiProvider} from "./gemini/GeminiProvider";
import {OllamaProvider} from "./ollama/OllamaProvider";
import {GrokProvider} from "./grok/GrokProvider";
import {AnthropicProvider} from "./anthropic/AnthropicProvider";

export interface AIProvider {
    priority: number
    name: string
    icon: ReactNode
    settingComponent: (props: AIProviderSettingsProps) => ReactNode
    models: string[]
}

export interface AIProviderSettings {
    id?: number,
    name: string,
    enabled: boolean,
    apiKey: string,
    models: string[]
}

export interface AIProviderSettingsProps {
    settings: AIProviderSettings,
    onChange: (settings: AIProviderSettings) => void
}

export const providers: AIProvider[] = [
    new OpenAIProvider(),
    new GeminiProvider(),
    new DeepSeekProvider(),
    new GrokProvider(),
    new AnthropicProvider(),
    new OllamaProvider()
]